export default max => Math.round(Math.random() * (max - 1))
